<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>
      <span style="opacity:.7; font-weight:400">CAESAR ·</span> {{ oldalCim() }}
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="felsoMenuValt()" [title]="felsoMenu ? 'Felső menüsáv elrejtése' : 'Felső menüsáv megjelenítése'">
        <ion-icon slot="icon-only" [name]="felsoMenu ? 'chevron-up-circle-outline' : 'chevron-down-circle-outline'"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar color="light" *ngIf="felsoMenu">
    <ion-segment scrollable [value]="aktivSzegmens()">
      <ion-segment-button value="ugyek" (click)="open('/caesar/ugyek')">
        <ion-icon name="briefcase"></ion-icon>
        <ion-label>Ügyek</ion-label>
      </ion-segment-button>
      <ion-segment-button value="teendok" (click)="open('/caesar/teendok')">
        <ion-icon name="calendar-number"></ion-icon>
        <ion-label>Teendők</ion-label>
      </ion-segment-button>
      <ion-segment-button value="iktato" (click)="open('/caesar/iktato')">
        <ion-icon name="file-tray-full"></ion-icon>
        <ion-label>Iktató</ion-label>
      </ion-segment-button>
      <ion-segment-button value="riportok" (click)="open('/caesar/riportok')">
        <ion-icon name="bar-chart"></ion-icon>
        <ion-label>Riportok</ion-label>
      </ion-segment-button>
      <ion-segment-button value="szemelyek" (click)="open('/caesar/szemelyek')">
        <ion-icon name="people"></ion-icon>
        <ion-label>Személyek</ion-label>
      </ion-segment-button>
      <ion-segment-button value="sablonok" (click)="open('/caesar/sablonok')">
        <ion-icon name="document-text"></ion-icon>
        <ion-label>Sablonok</ion-label>
      </ion-segment-button>
      <ion-segment-button value="ugytipusok" (click)="open('/caesar/ugytipusok')">
        <ion-icon name="options"></ion-icon>
        <ion-label>Ügytípusok</ion-label>
      </ion-segment-button>
      <ion-segment-button value="beallitasok" (click)="open('/caesar/beallitasok')">
        <ion-icon name="settings"></ion-icon>
        <ion-label>Beállítások</ion-label>
      </ion-segment-button>
    </ion-segment>
  </ion-toolbar>
</ion-header>

<ion-content>
  <router-outlet></router-outlet>
</ion-content>
